"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCatalogPageVideo = exports.CatalogPageVideo = void 0;
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var react_dom_1 = __importDefault(require("react-dom"));
var util_1 = require("@aperza/util");
var react_i18next_1 = require("react-i18next");
var ui_1 = require("@aperza/ui");
var CatalogPageVideo = function (_a) {
    var videoId = _a.videoId;
    var _b = ui_1.useYouTubeInfo(videoId), video = _b.video, loadingVideoInfo = _b.loadingVideoInfo, setVideoId = _b.setVideoId;
    var sendMessage = ui_1.useReactiveMessage('CATALOG_VIDEO').sendMessage;
    var _c = react_i18next_1.useTranslation('catalog'), t = _c.t, i18n = _c.i18n;
    react_1.useEffect(function () {
        setVideoId(videoId);
    }, [videoId]);
    var onClickVideo = function (e) {
        e.preventDefault();
        sendMessage({ video: video });
    };
    return (react_1.default.createElement("div", { className: "item" },
        loadingVideoInfo && react_1.default.createElement("span", null, "LOADING"),
        !loadingVideoInfo && video != null && video !== undefined && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "thumb" },
                react_1.default.createElement("a", { href: "#", className: "js_modal modal-youtube", onClick: onClickVideo, "data-videourl": "https://www.youtube.com/embed/" + video.videoId + "?&autoplay=1&rel=0" },
                    react_1.default.createElement("img", { alt: video.title, src: video.thumbnailUrl }))),
            react_1.default.createElement("div", { className: "desc" },
                react_1.default.createElement("p", null,
                    react_1.default.createElement("a", { href: "#", className: "js_modal modal-youtube", onClick: onClickVideo, "data-videourl": "https://www.youtube.com/embed/" + video.videoId + "?&autoplay=1&rel=0" }, video.title)),
                react_1.default.createElement("p", { className: "subTxt" }, video.authorName),
                react_1.default.createElement("p", { className: "subTxt" }, util_1.NumberUtil.formattedNumber(video.viewCount) + " " + t('catalog.video.view') + " | " + moment_1.default(video.publishedAt).locale(i18n.language).fromNow()),
                react_1.default.createElement("div", { className: "dtl" }, video.tags &&
                    video.tags.map(function (tag, i) { return (react_1.default.createElement("span", { key: i, className: "badge badge-default mr-1" }, tag)); })))))));
};
exports.CatalogPageVideo = CatalogPageVideo;
var renderCatalogPageVideo = function () {
    var _a;
    var catalogPageVideoDivId = 'catalog-page-video-component';
    var element = document.getElementById(catalogPageVideoDivId);
    if (element) {
        react_dom_1.default.render(react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
            react_1.default.createElement(exports.CatalogPageVideo, { videoId: (_a = element.getAttribute('data-video-id')) !== null && _a !== void 0 ? _a : undefined })), element);
    }
    else {
        console.warn("Trying to render VideoId in Catalog Page: " + element);
    }
};
exports.renderCatalogPageVideo = renderCatalogPageVideo;
exports.CatalogPageVideo.displayName = 'CatalogPageVideo';
